import {ExpressionPath, Plugins} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  ECall,
  EHole,
  EVariable,
  type Expression,
} from '@packages/systems/wfdl-ast';
import {
  ContextualExpression,
  getAnn,
} from '@packages/utilities/contextual-expression';

/**
 * Given a `ContextualExpression` representing a condition value, returns the
 * `ExpressionPath` to the operand implicit function's argument that represents
 * the condition source field.
 *
 * Assumes that `conditionValueExpr` is an expression within a call to
 * `Conditions::Apply predicate` that represents the first argument to
 * a predicate function that accepts just a single condition value argument.
 *
 * This utility is meant to be used when building TypeImplementations for
 * condition values with custom renders that require access to the condition
 * source field.
 */
export function getPathToOperandFromConditionValue(
  conditionValueExpr: ContextualExpression
): ExpressionPath {
  const path = getAnn(conditionValueExpr).env.expressionPath;
  return path.slice(0, -2).concat([
    {in: 'Call', at: 'fun'},
    {in: 'Call', at: 'arg'},
    {in: 'Call', at: 'arg'},
  ]);
}

export function buildNewCondition(
  maybeOperand?: Expression,
  maybePredicate?: Expression
) {
  return ECall({
    fun: ECall({
      fun: EVariable(
        qualify(Plugins.name('Conditions'), typeName('Apply predicate'))
      ),
      arg: maybeOperand || EHole(),
    }),
    arg: maybePredicate || EHole(),
  });
}
